import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCardApiValue, formatValue } from '../helpers';
import { checkKpiType } from '@flexo/general';

interface InformationCardContentLabelValueProps {
  description: string | any[];
  cardValue: { value?: any; unit?: string };
  overviewKpiApiData: any[];
  kpiContext: string;
  currencyFields: string[];
  id: string;
}

const InformationCardContentLabelValue: React.FC<InformationCardContentLabelValueProps> = ({ description, cardValue, overviewKpiApiData, kpiContext, currencyFields, id }) => {

  console.log('InformationCardContentLabelValue',
    description,
    cardValue,
    overviewKpiApiData,
    kpiContext,
    currencyFields,
    id
  );


  const { t } = useTranslation();
  if (typeof description === 'string') {
    return (
      <div>
        <span key={`${id}-label-value-label-description`} className="paragraph">
          {t(description)}
        </span>
        <span key={`${id}-label-value-card-value`} className="paragraph">
          <span className="heading5">{cardValue?.value || '-.-'}</span>
        </span>
      </div>
    );
  } else if (Array.isArray(description)) {
    return (
      <div key={`${id}-label-value-label-value-array`}>
        {description.map((el, i, array) => {
          const valueObj = getCardApiValue(el?.value, overviewKpiApiData, currencyFields);
          return (
            <div key={`${id}-label-value-label-value-array-${i}`}>
              <span className={`color-hive-greyscale-600`}>
                <span className="font-flexo-semibold heading5">
                  {t(el.key)}{' '}
                </span>
                {formatValue(valueObj?.value || '-.- ', kpiContext, checkKpiType) +
                  (valueObj?.unit || valueObj?.unit_type || '')}
              </span>
              {i < array.length - 1 && <br />}
            </div>
          );
        })}
      </div>
    );
  }
  return null;
};

export default InformationCardContentLabelValue; 